import { BreadCrumbs } from '@app/components/BreadCrumbs';
import { Layout } from '@app/components/Layout';

export function InstitutionalResources() {
  return (
    <Layout>
      <BreadCrumbs
        links={[
          {
            label: 'Student Portal',
            link: '/',
          },
          {
            label: 'Institutional Resources',
            link: '/institutional-resources',
          },
        ]}
      />
      Under Construction
    </Layout>
  );
}
